/**
 * @generated SignedSource<<66d85299ee587d7cc688aa13a68491fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ProductSkuOfferDeliveryChannel = "DELIVERY" | "PICKUP_IN_POINT" | "TAKE_AWAY";
import { FragmentRefs } from "relay-runtime";
export type ProductsShelfItem_ProductConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly _id: string;
      readonly id: string;
      readonly name: string;
      readonly defaultImage: {
        readonly url: string;
      };
      readonly skus: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly _id: string;
            readonly id: string;
            readonly name: string;
            readonly defaultImage: {
              readonly url: string;
            };
            readonly offers: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly sku: {
                    readonly _id: string;
                    readonly id: string;
                  };
                  readonly seller: {
                    readonly _id: string;
                  };
                  readonly deliveryChannel: ProductSkuOfferDeliveryChannel;
                  readonly listPrice: {
                    readonly amount: number;
                  };
                  readonly netPrice: {
                    readonly amount: number;
                  };
                  readonly priority: number;
                };
              }>;
              readonly " $fragmentSpreads": FragmentRefs<"ProductSkuAvailabilityDelivery_ProductSkuOfferConnection" | "ProductSkuAvailabilityPickup_ProductSkuOfferConnection" | "ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection">;
            } | null;
            readonly promotions: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly id: string;
                  readonly name: string;
                  readonly highlight: boolean | null;
                };
              }>;
            } | null;
            readonly images: {
              readonly edges: ReadonlyArray<{
                readonly node: {
                  readonly id: string;
                  readonly url: string;
                };
              }>;
            };
          };
        }>;
      };
      readonly offers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly sku: {
              readonly id: string;
              readonly _id: string;
            };
            readonly seller: {
              readonly _id: string;
            };
            readonly deliveryChannel: ProductSkuOfferDeliveryChannel;
            readonly listPrice: {
              readonly amount: number;
            };
            readonly netPrice: {
              readonly amount: number;
            };
            readonly priority: number;
          };
        }>;
        readonly " $fragmentSpreads": FragmentRefs<"ProductSkuAvailabilityDelivery_ProductSkuOfferConnection" | "ProductSkuAvailabilityPickup_ProductSkuOfferConnection" | "ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection">;
      } | null;
      readonly promotions: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string;
            readonly highlight: boolean | null;
          };
        }>;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"ProductSkuRef_Product">;
    };
  }>;
  readonly " $fragmentType": "ProductsShelfItem_ProductConnection";
};
export type ProductsShelfItem_ProductConnection$key = {
  readonly " $data"?: ProductsShelfItem_ProductConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductsShelfItem_ProductConnection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 420
    }
  ],
  "kind": "ScalarField",
  "name": "url",
  "storageKey": "url(size:420)"
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductSkuImage",
  "kind": "LinkedField",
  "name": "defaultImage",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "addresses",
    "variableName": "addresses"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Seller",
  "kind": "LinkedField",
  "name": "seller",
  "plural": false,
  "selections": [
    (v0/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliveryChannel",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "listPrice",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "netPrice",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v12 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ProductSkuAvailabilityDelivery_ProductSkuOfferConnection"
},
v13 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ProductSkuAvailabilityPickup_ProductSkuOfferConnection"
},
v14 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ProductSkuAvailabilityTakeAway_ProductSkuOfferConnection"
},
v15 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "PromotionConnection",
  "kind": "LinkedField",
  "name": "promotions",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PromotionEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Promotion",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "highlight",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "addresses"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductsShelfItem_ProductConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Product",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSkuConnection",
              "kind": "LinkedField",
              "name": "skus",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductSkuEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductSku",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        (v2/*: any*/),
                        (v4/*: any*/),
                        {
                          "alias": null,
                          "args": (v5/*: any*/),
                          "concreteType": "ProductSkuOfferConnection",
                          "kind": "LinkedField",
                          "name": "offers",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ProductSkuOfferEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ProductSkuOffer",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "ProductSku",
                                      "kind": "LinkedField",
                                      "name": "sku",
                                      "plural": false,
                                      "selections": [
                                        (v0/*: any*/),
                                        (v1/*: any*/)
                                      ],
                                      "storageKey": null
                                    },
                                    (v6/*: any*/),
                                    (v7/*: any*/),
                                    (v9/*: any*/),
                                    (v10/*: any*/),
                                    (v11/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            (v12/*: any*/),
                            (v13/*: any*/),
                            (v14/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v15/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProductSkuImageConnection",
                          "kind": "LinkedField",
                          "name": "images",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ProductSkuImageEdge",
                              "kind": "LinkedField",
                              "name": "edges",
                              "plural": true,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ProductSkuImage",
                                  "kind": "LinkedField",
                                  "name": "node",
                                  "plural": false,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v3/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v5/*: any*/),
              "concreteType": "ProductSkuOfferConnection",
              "kind": "LinkedField",
              "name": "offers",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductSkuOfferEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductSkuOffer",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProductSku",
                          "kind": "LinkedField",
                          "name": "sku",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/),
                            (v0/*: any*/)
                          ],
                          "storageKey": null
                        },
                        (v6/*: any*/),
                        (v7/*: any*/),
                        (v9/*: any*/),
                        (v10/*: any*/),
                        (v11/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v12/*: any*/),
                (v13/*: any*/),
                (v14/*: any*/)
              ],
              "storageKey": null
            },
            (v15/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProductSkuRef_Product"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductConnection",
  "abstractKey": null
};
})();

(node as any).hash = "76f409daf5cd4304fdb1f3b137c51a37";

export default node;
